module.exports = __webpack_public_path__ + "static/media/icon-app-dark.258f512b.svg";